import classNames from 'classnames';

import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import { images } from 'assets/images';
import { VIRTUAL_TOUR_EXAMPLES, COLOR } from 'config/constants';

const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
  },
  title: {
    marginBottom: 10,
    fontFamily: 'FordAntenna-Medium',
  },
  image: {
    width: '100%',
    height: 'auto',
    filter: 'brightness(0.8)',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  coverContent: {
    position: 'relative',
    width: '100%',
  },
  cover_icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 30,
    height: 30,
    zIndex: 2,
  },
  overlay: {
    position: 'absolute',
    backgroundColor: COLOR.TRANSPARENT_BLACK,
    width: '100%',
    height: '100%',
  },
  benefits: {
    marginBottom: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  descriptionRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  icon: {
    color: COLOR.LIGHT_BLUE,
    marginRight: 5,
    marginBottom: 5,
  },
});

function VirtualTourExamples() {
  const intl = useIntl();
  const classes = useStyles();

  const fmtTitle = intl.formatMessage({ id: 'deliver.virtualvisit.examples.title' });
  const fmtVirtualTourBenefit1 = intl.formatMessage({ id: 'deliver.virtualvisit.benefit1' });
  const fmtVirtualTourBenefit2 = intl.formatMessage({ id: 'deliver.virtualvisit.benefit2' });
  const fmtVirtualTourBenefit3 = intl.formatMessage({ id: 'deliver.virtualvisit.benefit3' });

  return (
    <div className={classes.content}>
      <Typography className={classes.title}>{fmtTitle}</Typography>
      <Grid container spacing={1} className={classes.row}>
        {VIRTUAL_TOUR_EXAMPLES.map((example, index) => {
          return (
            <Grid item md={6} className={classes.coverContent}>
              <a key={index} href={example.link} target='_blank' rel='noreferrer'>
                <img
                  src={images.virtual_tour_icon}
                  className={classes.cover_icon}
                  alt='virtual tour icon'
                />
                <img src={example.image} className={classes.image} alt='virtual tour' />
              </a>
            </Grid>
          );
        })}
      </Grid>
      <div className={classes.benefits}>
        <div className={classes.descriptionRow}>
          <CheckRoundedIcon className={classes.icon} />
          <Typography>{fmtVirtualTourBenefit1}</Typography>
        </div>
        <div className={classes.descriptionRow}>
          <CheckRoundedIcon className={classes.icon} />
          <Typography>{fmtVirtualTourBenefit2}</Typography>
        </div>
        <div className={classes.descriptionRow}>
          <CheckRoundedIcon className={classes.icon} />
          <Typography>{fmtVirtualTourBenefit3}</Typography>
        </div>
      </div>
    </div>
  );
}

export default memo(VirtualTourExamples);
